import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  class: "fill-current"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M21.3,10.1C20.7,9.4,19.9,9,19,9h-4.6L15,7.6c0.8-2.1-0.3-4.5-2.4-5.3C12.1,2.1,11.6,2,11.1,2c-0.4,0-0.8,0.2-0.9,0.6L7.3,9H5c-1.7,0-3,1.3-3,3v7c0,1.7,1.3,3,3,3h12.7c1.5,0,2.7-1,3-2.5l1.3-7C22.1,11.7,21.9,10.8,21.3,10.1z M7,20H5c-0.6,0-1-0.4-1-1v-7c0-0.6,0.4-1,1-1h2V20z" }, null, -1)
  ])))
}
export default { render: render }